import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Spinner } from '@/components/ui/spinner';
import { recordInstallIntent } from '@/api/cafe24Api';

/**
 * 카페24 "설치" 버튼의 목적지(§5.1 온보딩, "설치 전 로그인 상태 유지" 방식).
 * ProtectedRoute로 감싸져 있어 비로그인 시 자동으로 /login으로 보내지고
 * redirectAfterLogin으로 로그인 후 이 페이지로 복귀한다.
 */
export const Cafe24InstallLanding: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const hasRunRef = useRef(false);

  useEffect(() => {
    const mallId = searchParams.get('mall_id');
    if (!mallId) {
      setError('잘못된 접근입니다 (mall_id 파라미터가 없습니다).');
      return;
    }
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    (async () => {
      try {
        // B/E가 이 설치 시도의 userId를 OAuth state에 바인딩하고, 그대로 이동할
        // 카페24 authorize URL을 돌려준다(2026-08-20 보안 수정 - install-intent가
        // DB에 mallId를 미리 선점하던 취약점 제거, 상세는 alttext_be 쪽 참고).
        const { authorizeUrl } = await recordInstallIntent(mallId);
        window.location.href = authorizeUrl;
      } catch {
        // install-intent는 DB를 건드리지 않으므로(2026-08-20 보안 수정) 이 시점엔
        // "이미 연동됨" 같은 구체적 사유가 없다 - 실제 소유권 충돌은 카페24 동의를
        // 거친 뒤 콜백(/cafe24/connect?status=already_linked)에서 판별된다.
        setError('설치 준비 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
      }
    })();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center px-4">
        {error ? (
          <p className="text-red-600">{error}</p>
        ) : (
          <>
            <Spinner size="2xl" className="mx-auto mb-4 text-primary" />
            <p className="text-gray-600">카페24 설치를 준비하는 중...</p>
          </>
        )}
      </div>
    </div>
  );
};
